export const ADMIN_ROLES = ["super_admin", "admin", "moderator"];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  moderator: "Modérateur",
  user: "Utilisateur",
  partner: "Partenaire",
};

const PERMS = {
  super_admin: ["*"],
  admin: ["users.view", "users.moderate", "users.manage", "contents", "quiz",
    "ai", "stats", "support", "partners", "audit", "moderation"],
  moderator: ["users.view", "users.moderate", "contents", "support", "moderation"],
};

export const isAdminRole = (user) => ADMIN_ROLES.includes(user?.role);

export const can = (user, perm) => {
  const p = PERMS[user?.role] || [];
  return p.includes("*") || p.includes(perm);
};
